import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import SvgIcon from '../SvgIcon.js';
var IconIcTelegramNotificationIcon = props => /*#__PURE__*/
// eslint-disable-next-line react/jsx-props-no-spreading
React.createElement(SvgIcon, _extends({}, props, {
  viewBox: "0 0 40 40",
  iconname: "IconIcTelegramNotificationIcon"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#pathTo_Svg__Clip0_6001_847)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#pathTo_Svg__Clip1_6001_847)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.8 0H4.2C1.8804 0 0 1.8804 0 4.2V23.8C0 26.1196 1.8804 28 4.2 28H23.8C26.1196 28 28 26.1196 28 23.8V4.2C28 1.8804 26.1196 0 23.8 0Z",
  fill: "#29B6F6"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#pathTo_Svg__Clip2_6001_847)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.3801 -1C8.83145 -1 5.42818 0.409681 2.91893 2.91893C0.409681 5.42818 -1 8.83145 -1 12.3801C-1 15.9287 0.409681 19.3319 2.91893 21.8412C5.42818 24.3504 8.83145 25.7601 12.3801 25.7601C15.9287 25.7601 19.3319 24.3504 21.8412 21.8412C24.3504 19.3319 25.7601 15.9287 25.7601 12.3801C25.7601 8.83145 24.3504 5.42818 21.8412 2.91893C19.3319 0.409681 15.9287 -1 12.3801 -1Z",
  fill: "#29B6F6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.8589 8.15155L18.201 20.3376C18.201 20.3376 18.0867 20.8945 17.3176 20.8945C16.9089 20.8945 16.6981 20.7199 16.6981 20.7199L10.9409 16.43L8.12395 15.1551L4.50879 14.2917C4.50879 14.2917 3.86523 14.1248 3.86523 13.6469C3.86523 13.2487 4.52724 13.0588 4.52724 13.0588L19.652 7.6635C19.652 7.6635 20.1139 7.51377 20.4509 7.51441C20.6581 7.51441 20.8944 7.59405 20.8944 7.83298C20.8944 7.99227 20.8589 8.15155 20.8589 8.15155Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.38 17.3573L10.2927 20.7726C10.2927 20.7726 10.2019 20.8891 10.0807 20.8941C10.0387 20.8961 9.99357 20.885 9.94727 20.8506L10.5346 14.8125L12.38 17.3573Z",
  fill: "#B0BEC5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.9752 10.0814C15.8871 9.93048 15.7245 9.90304 15.6098 10.0176L8.73047 15.4354C8.73047 15.4354 9.82837 19.4776 9.99571 20.1774C10.1636 20.8779 10.2981 20.8943 10.2981 20.8943L10.8006 16.802L15.9262 10.5617C16.0409 10.4471 16.0623 10.2323 15.9752 10.0814Z",
  fill: "#CFD8DC"
}))), /*#__PURE__*/React.createElement("rect", {
  x: "20",
  y: "20",
  width: "20",
  height: "20",
  rx: "2",
  fill: "#F57138"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.8132 23.8882C32.1235 23.9713 32.3096 24.2828 32.229 24.5839L32.0725 25.1677C33.9075 25.9428 34.9465 27.926 34.4313 29.8486L33.8178 32.1384L34.3072 33.1575C34.7268 34.0312 33.9175 34.9699 32.9649 34.7147L25.403 32.6885C24.4504 32.4332 24.2189 31.2156 25.019 30.6688L25.9525 30.0309L26.566 27.7412C27.0812 25.8186 28.9723 24.6207 30.9489 24.8667L31.1054 24.2828C31.186 23.9817 31.503 23.805 31.8132 23.8882Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.6435 35.0121C26.527 34.7647 26.4537 34.4904 26.4272 34.2034L29.9633 35.1509C29.797 35.3862 29.5963 35.5871 29.3717 35.7431C29.1358 35.9069 28.8781 36.0179 28.6133 36.0698C28.3486 36.1218 28.0819 36.1135 27.8286 36.0457C27.5753 35.9778 27.3402 35.8516 27.1369 35.6742C26.9335 35.4969 26.7659 35.2719 26.6435 35.0121Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "pathTo_Svg__Clip0_6001_847"
}, /*#__PURE__*/React.createElement("rect", {
  width: "40",
  height: "40",
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "pathTo_Svg__Clip1_6001_847"
}, /*#__PURE__*/React.createElement("rect", {
  width: "28",
  height: "28",
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "pathTo_Svg__Clip2_6001_847"
}, /*#__PURE__*/React.createElement("rect", {
  width: "44.8",
  height: "44.8",
  fill: "white"
}))));
export { IconIcTelegramNotificationIcon as default };
//# sourceMappingURL=IconIcTelegramNotificationIcon.js.map